<div
  class="layout"
  id="scrolling-container"
  hidden>
  <a
    class="skip-link"
    (click)="skipToMainContent($event)"
    href="#main-content">
    {{ 'common.skip-to-main-content' | transloco }}
  </a>
  <div class="layout_content">
    <main
      id="main-content"
      tabindex="-1"
      class="layout_main"
      autoscroll="true"
      ui-view></main>
  </div>
  <div class="layout_footer">
    <app-legal-terms-footer />
  </div>
</div>

<app-icons-sprite></app-icons-sprite>
